import {h, Fragment} from "preact"
import { useAppStateSelector, useProductFilters } from "@nosto/preact"
import { useMemo, useEffect, useRef } from "preact/hooks"
import { searchProductCountEl, fetchSearchTotal } from "../helpers"
import { variantFilterMatch } from "../config"

import Product from "./Product"

export default function Products() {
    const { 
        products, loading, pageType, query
     } = useAppStateSelector(state => ({ 
        products: state.response.products, 
        loading: state.loading, 
        pageType: state.pageType,
        query: state.query
    }));
    const { filters } = useProductFilters()

    const activeFilters = useMemo(() => {
        return filters.filter(f => variantFilterMatch.find(field => field.filterField === f.field))?.reverse() || [];
    }, [ filters, variantFilterMatch ]);

    const lastQuery = useRef(null);

    useEffect(() => { 
        // update search total - separate query in case page loads with filters
        if(pageType !== "search" || !searchProductCountEl || !query?.query) return;
        const fetchTotal = async () => {
            if(lastQuery?.current !== query.query) {
                lastQuery.current = query.query;
                const unfilteredTotal = await fetchSearchTotal(query.query);
                searchProductCountEl.textContent = `Products (${unfilteredTotal ?? 0})`
                document.title = `Search: ${unfilteredTotal ?? 0} results found for "${query.query}"`
            }
        }
        fetchTotal();
    }, [ pageType, query?.query ])

    return (
        <div 
            id="nosto-product-grid-container"
            class="group/grid flex-1" 
            style={loading ? "opacity: 0.3;" : ""}
            // product-grid-container=""
            // sub-section-id="product-grid-container"
        >
            <div>
                <ul class="grid grid-cols-2 group-aria-expanded/grid:grid-cols-1 gap-[10px] lg:grid-cols-3 lg:group-aria-expanded/grid:grid-cols-3">
                    {products.hits.map((hit, index) => (
                        <Product 
                            key={hit.productId || index}
                            product={hit} 
                            activeFilters={activeFilters}
                        />
                    ))}
                </ul>
            </div>
        </div>
    )
}
